import { MenuItem } from 'primeng/api/menuitem';
import { InjectionToken } from '@angular/core';

export const AppMenu = new InjectionToken<MenuInterface>('AppMenu');

export interface MenuInterface {
	getMenu(): MenuItem[];
}